import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  completeOrderButtonContainer: {
    padding: `0 ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium}`,
    '& button': {
      width: '100%',
    },
  },
}));

export default useStyles;
